import React, { useEffect } from "react";
import "./DogPark.css";

function DogPark() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    <div className="dog-park-container">
      <h2 className="dog-park-title">Welcome to DJ's Dog Park!</h2>
      <p className="dog-park-description">
        At DJ's Dog Park, we've designed the perfect environment for your dog to enjoy and thrive. Our park features a spacious, lush turf area that provides a soft and comfortable surface for running, playing, and lounging. Unlike traditional grass, our high-quality turf ensures a clean and mud-free experience, no matter the weather.
      </p>
      <div className="dog-park-image">
        <img
          src="https://res.cloudinary.com/dboapnol9/image/upload/v1779136051/DSC_0562_fid5ig.jpg"
          alt="A tan and white dog with a collar standing in the park and looking at the camera"
        />
      </div>
      <p className="dog-park-description">
        Our attentive park rangers are always on-site, ready to ensure a safe and positive experience for all our guests. They are trained to manage any situation that may arise, ensuring that dogs of all sizes and temperaments can enjoy themselves while keeping the atmosphere fun and friendly. From greeting new arrivals to monitoring playtime, our team is dedicated to creating a safe and enjoyable environment for everyone.
      </p>
      <div className="dog-park-image">
        <img
          src="https://res.cloudinary.com/dboapnol9/image/upload/v1780002449/DSC_0619_xgv5hv.jpg"
          alt="A group of dogs interacting in the grassy dog park with their owners nearby"
        />
      </div>
      <p className="dog-park-description">
        In addition to our turf area, we offer multiple water stations to keep your dog hydrated and refreshed, as well as shaded seating areas for you to relax comfortably while your pup plays. Agility equipment is available throughout the park to encourage your dog's natural curiosity and physical fitness, providing endless entertainment for energetic pups.
      </p>
      <div className="dog-park-image">
        <img
          src="https://res.cloudinary.com/dboapnol9/image/upload/v1780000522/DSC_0603_ef1736.jpg"
          alt="A tan dog with a floral collar looking at the camera in the dog park"
        />
      </div>
      <p className="dog-park-description">
        Whether it's a fun day of exercise or a relaxing outing with fellow dog lovers, DJ's Dog Park has everything you need for an amazing time. Come visit us and experience a dog park designed with both dogs and their owners in mind—a place where safety, fun, and community come together.
      </p>
    </div>
      <div style={{ 
        aspectRatio: "960/100", 
        backgroundImage: "url('/blueToPinkFooter.png')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }}></div>
  </>
  );
}

export default DogPark;
